<template>
  <div>
    <div class="d-flex justify-content-between">
      <history-packet-modal></history-packet-modal>
      <div class="d-flex col-sm-6 padding-left-0">
        <div class="col-sm-6 padding-left-0">
          <multiselect v-model="template" :max-height="200"
                       placeholder="" label="name" track-by="name"
                       :options="packetsGridTemplates" :multiple="false"
                       :close-on-select="true" @input="applyTemplate"
                       :disabled="!packets.length"
                       select-label="" deselect-label="" selected-label=""
          ></multiselect>
        </div>
        <div class="button-group d-flex col-sm-6">
          <b-btn size="sm" title="Create new template" style="margin-left: 0" :disabled="!packets.length"
                 @click="createTemplate">
            {{$t('buttons.common.create')}}
          </b-btn>
          <b-btn size="sm" title="Delete selected template" variant="outline-danger" :disabled="!template"
                 @click="deleteSelectedTemplate">
            {{$t('buttons.common.delete')}}
          </b-btn>
          <b-btn size="sm" title="Update selected template" variant="outline-success" :disabled="!template"
                 @click="updateSelectedTemplate">
            {{$t('buttons.common.update')}}
          </b-btn>
        </div>
      </div>
      <div class="d-flex justify-content-end col-sm-6 padding-right-0">
        <b-popover target="add-to-operation" placement="bottom" ref="add-to-operation-popover">
          <div class="d-flex align-items-center">
            <label>{{$t('labels.operations.duplicate_package_nr')}}</label>
            <input type="checkbox" ref="clone_packets" class="margin-left-5">
          </div>
          <div class="d-flex">
            <multiselect v-model="bounded_operation" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="active_operations" select-label=""
            ></multiselect>
            <b-btn size="sm" variant="success" class="margin-left-5" @click="addPackageToOperation"
                   title="Add selected packages to selected operation" :disabled="!bounded_operation">
              {{$t('buttons.common.add')}}
            </b-btn>
          </div>
        </b-popover>
        <div class="button-group d-flex">
          <b-btn size="sm" @click="printLabels" title="Print labels for selected packages">
            {{$t('common_content.labels')}}
          </b-btn>
          <b-btn size="sm" variant="outline-success" @click="createOperationWithPackages"
                 title="Create operation with selected packages">
            {{$t('buttons.operations.create_operation')}}
          </b-btn>
          <b-btn size="sm" variant="outline-primary" id="add-to-operation">
            {{$t('buttons.operations.add_to_operation')}}
          </b-btn>
          <img src="@/assets/images/common-icons/icon_clear.png" @click="cleanFilters"
               :title="$t('buttons.common.clear_filters')">
          <img src="@/assets/images/common-icons/icon_search.svg" @click="search"
               :title="$t('buttons.common.search')">
        </div>
      </div>
    </div>
    <div class="search-form">
      <div class="search-form__filters">
        <b-row>
          <b-col>
            <label>{{$t('labels.common.group')}}</label>
            <multiselect v-model="searchData.group" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="groups" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""
            ></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.wood')}}</label>
            <multiselect v-model="searchData.tree" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="wood" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.quality')}}</label>
            <multiselect v-model="searchData.quality" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="qualities_list" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.pellets.diameter')}}</label>
            <multiselect v-model="searchData.diameter" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="pellet_diameters" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>{{$t('labels.common.smart_search')}}
              <smart-search-badge></smart-search-badge>
            </label>
            <input class="form-control" v-model="searchData.smart_search" @keyup.enter="search()">
          </b-col>
          <b-col>
            <label>{{$t('labels.common.package_nr')}}</label>
            <input class="form-control" v-model="searchData.package_nr"
                   @keyup.enter="search()">
          </b-col>
          <b-col>
            <label>{{$t('labels.pellets.bag_logo')}}</label>
            <multiselect v-model="searchData.bag_logo" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="bag_logos" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.package_type')}}</label>
            <multiselect v-model="searchData.package_type" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="packageTypes" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-between toggle-container" @click="showCollapse = !showCollapse"
             :aria-expanded="showCollapse  ? 'true' : 'false'"
             aria-controls="collapse">
          <h3>
            {{$t('common_content.advanced_search')}}
          </h3>
          <div class="icons-wrapper">
            <icon name="angle-down" class="angle" v-if="showCollapse"></icon>
            <icon name="angle-right" class="angle" v-else></icon>
          </div>
        </div>
        <b-collapse id="collapse" v-model="showCollapse">
          <b-row>
            <b-col>
              <label>{{$t('labels.pellets.unit_weight')}}</label>
              <multiselect v-model="searchData.unit_weight"
                           :max-height="200"
                           placeholder="" label="" track-by=""
                           :options="unit_weights" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.locating')}}</label>
              <multiselect v-model="searchData.locations" :max-height="200"
                           placeholder="" label="name" track-by="name"
                           :options="locations" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.start_date')}}</label>
              <datepicker v-model="searchData.start_date" lang="en"
                          placeholder=""
                          :width="170"
                          :first-day-of-week="1"
              ></datepicker>
            </b-col>
            <b-col>
              <label>{{$t('labels.operations.operation_type')}}</label>
              <multiselect v-model="searchData.processes" :max-height="200"
                           placeholder="" label="name" track-by="id"
                           :options="processes" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label>{{$t('labels.pellets.total_weight')}}</label>
              <multiselect v-model="searchData.weight"
                           :max-height="200"
                           placeholder="" label="" track-by=""
                           :options="total_weights" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""> </multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.stock')}}</label>
              <multiselect v-model="searchData.stock_addresses" :max-height="200"
                           placeholder="" label="name" track-by="id"
                           :options="stock_addresses" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.end_date')}}</label>
              <datepicker v-model="searchData.end_date" lang="en"
                          placeholder=""
                          :width="170"
                          :first-day-of-week="1"
              ></datepicker>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.delivery_address')}}</label>
              <multiselect v-model="searchData.delivery_addresses" :max-height="200"
                           placeholder="" label="name" track-by="id"
                           :options="delivery_addresses" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label>{{$t('labels.pellets.pallet_size')}}</label>
              <multiselect v-model="searchData.pallet_size" :max-height="200"
                           placeholder="" label="name" track-by="id"
                           :options="pallet_sizes" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
            <b-col>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.supplier')}}/{{$t('labels.common.buyer')}}</label>
              <multiselect v-model="searchData.partners" :max-height="200"
                           placeholder="" label="name" track-by="id"
                           :options="partners" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.certificate')}}</label>
              <multiselect v-model="searchData.wood_certificate" :max-height="200"
                           placeholder="" label="name" track-by="id"
                           :options="wood_certificates" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label>{{$t('labels.common.quantity')}}</label>
              <multiselect v-model="searchData.pieces"
                           placeholder=""
                           :options="pieces_list" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
            <b-col>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.locating_in_operation')}}</label>
              <multiselect v-model="searchData.operationType" :max-height="200"
                           placeholder="Choose operation type" label="name" track-by="name"
                           :options="operationTypes" :multiple="false"
                           :close-on-select="true" :allowEmpty="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.executor')}}</label>
              <multiselect v-model="searchData.user" :max-height="200"
                           placeholder="" label="username" track-by="id"
                           :options="users" :multiple="true"
                           :close-on-select="false"
                           select-label="" deselect-label="" selected-label=""></multiselect>
            </b-col>
          </b-row>
        </b-collapse>
      </div>
    </div>
    <div>
      <package-modal></package-modal>
      <b-row>
        <b-col class="d-flex justify-content-start align-items-center">
                    <span v-for="item in totalData" :key="item.text" class="total-info__item">
                        {{$t(`labels.common.${item.label}`)}}: {{item.value.toLocaleString('ru-RU')}}
                    </span>
        </b-col>
        <b-col class="d-flex justify-content-end align-items-center">
                    <span v-for="item in selectedData" :key="item.text" class="selected-info__item">
                        {{$t(`labels.common.${item.label}`)}}: {{item.value.toLocaleString('ru-RU')}}
                    </span>
          <save-columns-btn :grid="gridOptions" :grid-name="gridName"
                            class="margin-left-5"></save-columns-btn>
        </b-col>
      </b-row>
    </div>
    <div>
      <b-row>
        <b-col>
          <ag-grid-vue class="ag-theme-balham" :gridOptions="gridOptions"
                       :style="gridHeight" :rowData="packets" :columnDefs="columns"
                       @selectionChanged="selectionChangedOperations"
                       @filterChanged="filterChanged" @rowDoubleClicked="openHistoryPacketDialog"
                       :getContextMenuItems="getContextMenuItems" :postProcessPopup="postProcessPopup">
          </ag-grid-vue>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';
  import { AgGridVue } from 'ag-grid-vue';
  import Multiselect from 'vue-multiselect';
  import Datepicker from 'vue2-datepicker';
  import HistoryPacketModal from '@/components/modals/HistoryPacketModal';
  import PackageModal from '@/components/modals/PackageModal';
  import SaveColumnsBtn from '@/components/common/SaveColumnsBtn';
  import SmartSearchBadge from '@/components/common/SmartSearchBadge';
  import moment from 'moment';

  import {
    cleanFilters,
    getArrayByProperty,
    handlerResponse,
    setNotifyData,
    sumTotalData,
    getFilteredNodes,
    getFilteredSelectedNodes
  } from '@/helpers/commonHelpers';

  import { notificationsRenderer, autoResize } from '@/helpers/renderHelpers';

  import { generateManyPagesForContent } from '@/helpers/createPdfLabel';
  import exportExcel from '@/helpers/export-excel-helper';
  import { gridMixins } from '@/mixins';
  import { DATE_FORMAT } from '@/constants';

  export default {
    mixins: [gridMixins],
    components: {
      Multiselect,
      'ag-grid-vue': AgGridVue,
      Datepicker,
      HistoryPacketModal,
      SaveColumnsBtn,
      PackageModal,
      SmartSearchBadge
    },
    data() {
      return {
        showCollapse: false,
        operationTypes: [
          {name: this.$i18n.t('selects.to_stock'), key: 'i'},
          {name: this.$i18n.t('selects.from_stock'), key: 'o'},
          {name: `${this.$i18n.t('selects.from_stock')} / ${this.$i18n.t('selects.to_stock')}`, key: 'io'}
        ],
        locations: [
          {name: this.$i18n.t('selects.stock'), value: 'STOCK'},
          {name: this.$i18n.t('selects.production'), value: 'MOVE'},
          {name: this.$i18n.t('selects.shipped'), value: 'CLOSE'}
        ],
        selectedData: [
          {
            label: 'selected_packets',
            value: 0
          },
          {
            label: 'quantity',
            value: 0,
            key: 'pieces'
          },
          {
            label: 'total_weight',
            value: 0,
            key: 'weight'
          }
        ],
        searchData: {
          group: [],
          tree: [],
          quality: [],
          diameter: [],
          name: '',
          package_nr: '',
          wood_certificate: [],
          delivery_addresses: [],
          stock_addresses: [],
          user: [],
          partners: [],
          processes: [],
          production_places: [],
          operationType: null,
          start_date: null,
          end_date: null,
          locations: [],
          weight: [],
          unit_weight: [],
          pallet_size: [],
          pieces: [],
          package_type: []
        },
        templates: [],
        template: null,
        defaultGridTemplate: {
          params: [],
          filters: {}
        },
        gridNameForTemplates: 'packets_search',
        active_operations: [],
        bounded_operation: null,
        storageKey: 'packetsSearch'
      }
    },
    methods: {
      cleanFilters() {
        cleanFilters(this.searchData, this.storageKey);
        this.setDefaultFilters();
      },
      search() {
        const searchData = this.prepareSearchData();
        this.$store.dispatch('packets/loadPackets', searchData).then(() => {
          if (this.template) {
            this.applyTemplate(this.template);
          } else {
            this.setDefaultGridTemplate();
          }
          this.selectedData = sumTotalData([], this.selectedData);
          //saveFilters(this.storageKey, this.searchData);
        });
      },
      prepareSearchData() {
        const searchData = {
          condition: 'main',
          group: getArrayByProperty(this.searchData.group, 'id').toString(),
          tree: getArrayByProperty(this.searchData.tree, 'id').toString(),
          quality: getArrayByProperty(this.searchData.quality, 'id').toString(),
          diameter: getArrayByProperty(this.searchData.diameter, 'id').toString(),
          smart_search: this.searchData.smart_search,
          package_nr: this.searchData.package_nr,
          bag_logo: getArrayByProperty(this.searchData.bag_logo, 'id').toString(),
          package_type: getArrayByProperty(this.searchData.package_type, 'id').toString(),
          wood_certificate: getArrayByProperty(this.searchData.wood_certificate, 'id').toString(),
          delivery_addresses: getArrayByProperty(this.searchData.delivery_addresses, 'id').toString(),
          stock_addresses: getArrayByProperty(this.searchData.stock_addresses, 'id').toString(),
          unit_weight: this.searchData.unit_weight && this.searchData.unit_weight.toString(),
          weight: this.searchData.weight && this.searchData.weight.toString(),
          pallet_size: getArrayByProperty(this.searchData.pallet_size, 'id').toString(),
          pieces: this.searchData.pieces.toString(),
          partner: this.searchData.processes.length === 0 ? getArrayByProperty(this.searchData.partners, 'id').toString() : ''
        };
        if (!this.isOperationDate) {
          searchData.packets_date_between_after = this.searchData.start_date ? moment(this.searchData.start_date).format(DATE_FORMAT) : '';
          searchData.packets_date_between_before = this.searchData.end_date ? moment(this.searchData.end_date).format(DATE_FORMAT) : '';
        }
        searchData.process_type_access = this.generateProcessTypeAccessField();
        return searchData;
      },
      generateProcessTypeAccessField() {
        return `${this.searchData.operationType.key}, [${getArrayByProperty(this.searchData.processes, 'id')}], ` +
          `[${this.searchData.start_date && this.isOperationDate ? moment(this.searchData.start_date).format(DATE_FORMAT) : ''}], ` +
          `[${this.searchData.end_date && this.isOperationDate ? moment(this.searchData.end_date).format(DATE_FORMAT) : ''}], ` +
          `[${getArrayByProperty(this.searchData.production_places, 'id')}], ` +
          `[${getArrayByProperty(this.searchData.user, 'id')}], [${this.searchData.processes.length !== 0 ? getArrayByProperty(this.searchData.partners, 'id') : ''}], ` +
          `[${getArrayByProperty(this.searchData.locations, 'value')}]`;
      },
      selectionChangedOperations() {
        const selectedPackets = this.gridOptions.api.getSelectedRows();
        this.selectedData = sumTotalData(selectedPackets, this.selectedData);
      },
      filterChanged () {
        this.filteredData = getFilteredNodes(this.gridOptions).map(item => item.data);
        this.$store.commit('packets/setTotalData', this.filteredData);
        this.gridOptions.api.deselectAll();
      },
      setDefaultFilters() {
        this.searchData.operationType = this.operationTypes.find(item => item.key === 'i');
        this.searchData.locations = [
          {name: this.$i18n.t('selects.stock'), value: 'STOCK'},
          {name: this.$i18n.t('selects.production'), value: 'MOVE'}
        ];
        this.searchData.stock_addresses = this.stock_addresses.filter(address => address.name === 'Granules');
        this.searchData.group = this.groups.filter(group => group.name === 'BIO Granules');
        this.template = null;
      },
      setDefaultGridTemplate() {
        this.defaultGridTemplate.params = this.gridOptions.columnApi.getColumnState();
        this.defaultGridTemplate.filters = this.gridOptions.api.getFilterModel();
      },
      applyTemplate(currentTemplate) {
        if (currentTemplate) {
          this.gridOptions.columnApi.setColumnState(currentTemplate.params);
          this.gridOptions.api.setFilterModel(currentTemplate.filters);
        } else {
          this.gridOptions.columnApi.setColumnState(this.defaultGridTemplate.params);
          this.gridOptions.api.setFilterModel(this.defaultGridTemplate.filters);
        }
        this.$nextTick(() => {
          autoResize(this.gridOptions);
        })
      },
      prepareDialog() {
        return {
          title: this.$i18n.t(`text_content.creating_grid_template`),
          input: 'text',
          inputPlaceholder: this.$i18n.t(`placeholders.enter_grid_template_name`),
          showCancelButton: true,
          cancelButtonText: this.$i18n.t(`buttons.common.cancel`)
        }
      },
      createTemplate() {
        this.$swal.fire(this.prepareDialog()).then(result => {
          const templateName = result.value;
          if (templateName) {
            const params = this.gridOptions.columnApi.getColumnState(),
              name = templateName, filters = this.gridOptions.api.getFilterModel(),
              grid_name = this.gridNameForTemplates;
            const savedData = {params, name, grid_name, filters};
            this.$http.post(`generic/pivot_grid_table_templates/`, savedData).then(handlerResponse).then((response) => {
              const templateName = response.name;
              this.$notify(setNotifyData(this.$i18n.t(`notifications.common.grid_template_created`, {templateName}), '', 'success'));
              this.$store.dispatch('generic/getGridTemplates', this.gridNameForTemplates);
            }).catch(error => notificationsRenderer(error.data, 'error'));
          }
        });
      },
      deleteSelectedTemplate() {
        const templateId = this.template.id, templateName = this.template.name;
        this.$http.delete(`generic/pivot_grid_table_templates/${templateId}/`).then(() => {
          this.template = null;
          this.$notify(setNotifyData(this.$i18n.t(`notifications.common.grid_template_deleted`, {templateName}), '', 'success'));
          this.$store.dispatch('generic/getGridTemplates', this.gridNameForTemplates);
        }).catch(error => notificationsRenderer(error.data, 'error'));
      },
      updateSelectedTemplate() {
        const templateId = this.template.id, templateName = this.template.name,
          params = this.gridOptions.columnApi.getColumnState(),
          grid_name = this.gridNameForTemplates, filters = this.gridOptions.api.getFilterModel();
        const savedData = {grid_name, filters, params};
        this.$http.put(`generic/pivot_grid_table_templates/${templateId}/`, savedData).then(() => {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.common.grid_template_updated`, {templateName}), '', 'success'));
          this.$store.dispatch('generic/getGridTemplates', this.gridNameForTemplates);
        }).catch(error => notificationsRenderer(error.data, 'error'));
      },
      getActiveOperations() {
        const params = {
          status: 'A',
          packet_type_access: 'io,o'
        };
        this.$http.get(`woodware/search_for_movement/`, {params}).then(handlerResponse).then(response => {
          this.active_operations = response.data;
        })
      },
      printLabels() {
        const selectedRows = getFilteredSelectedNodes(this.gridOptions);
        if (selectedRows.length) {
          const payload = {
            columns: ['package_nr', 'tree_name', 'profile_name', 'quality', 'partner_name', 'amount', 'moved_to_stock_date'],
            packages: selectedRows.map(item => item.data.id),
            print_children: true
          };
          this.$http.post(`woodware/packages_data_for_label/`, payload).then(handlerResponse).then(response => {
            const win = window.open('', '_blank');
            const labelData = generateManyPagesForContent(response);
            pdfMake.createPdf(labelData).open({}, win);
          }).catch(error => notificationsRenderer(error.data, 'error'));
        } else {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.packages.select_to_print`), '', 'warn'));
        }
      },
      createOperationWithPackages() {
        const selectedRows = getFilteredSelectedNodes(this.gridOptions);
        if (selectedRows.length) {
          const packages = selectedRows.map(item => item.data.package_nr).toString();
          this.$router.push({path: `/operation/new`, query: {packages}});
        } else {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.packages.select_for_create_operation`), '', 'warn'));
        }
      },
      addPackageToOperation() {
        const selectedRows = getFilteredSelectedNodes(this.gridOptions);
        if (selectedRows.length) {
          const packets = selectedRows.map(item => item.data.id);
          const payload = {
            packets,
            movement: this.bounded_operation.id,
            clone_packets: this.$refs['clone_packets'].checked
          }
          this.$http.post(`woodware/update_movement_data_on_stock_from_stock/`, payload).then(handlerResponse).then(response => {
            this.closePopovers();
            this.bounded_operation = null;
            this.$refs['clone_packets'].checked = false;
            const notifyType = response.fully_succeeded ? 'success' : 'warn';
            this.$notify(setNotifyData(response.message, '', notifyType));
            this.$store.dispatch(`woodware/fetchOperations`);
          });
        } else {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.packages.select_for_add_to_operation`), '', 'warn'));
        }
      },
      openPackageModal(data) {
        this.$root.$emit('openPackageModal', data);
      },
      fetchPackageInfo(packageId) {
        this.$http.get(`woodware/movement_data/${packageId}/`).then(handlerResponse).then(response => {
          const data = {
            editable: false,
            ...response
          };
          this.closePopovers();
          this.openPackageModal(data);
        }).catch(error => notificationsRenderer(error.data, 'error'));
      },
      async generateShipmentSpecificationReport() {
        const payload = {
          id: getFilteredSelectedNodes(this.gridOptions).map(item => item.data.id)
        };
        if (payload.id.length) {
          exportExcel(`woodware/report/shipment_specification/`, payload, 'post');
        }
      },
      getContextMenuItems(params) {
        const node = params.node;
        let menuItems = ['autoSizeAll', 'copy', 'export'];
        const exportSelected = {
          name: this.$i18n.t(`grid_settings.export_selected_rows`),
          action: () => {
            const params = {
              onlySelected: true,
              fileName: 'Packages report'
            };
            this.gridOptions.api.exportDataAsExcel(params);
          }
        };
        menuItems = [...menuItems, exportSelected];
        if (node && node.data) {
          const packageNumber = node.data.package_nr;
          const subpackageMenuItem = {
            name: this.$i18n.t(`grid_settings.show_info_of_package`, {packageNumber}),
            disabled: node.group,
            action: () => {
              const packageId = node.data.id;
              this.fetchPackageInfo(packageId);
            }
          };
          menuItems = [subpackageMenuItem, ...menuItems];
        }

        return menuItems;
      },
      openHistoryPacketDialog(rowData) {
        if (rowData.data) {
          this.closePopovers();
          if (rowData.data.package_nr) {
            this.$root.$emit('openHistoryPacketModal', rowData);
          } else {
            this.$swal.fire('', `Package number aren't yet generated!`, 'info');
          }
        } else {
          this.$swal.fire('', `For showing history of packet double click to packet row!`, 'warning');
        }
      },
      closePopovers() {
        this.$refs['add-to-operation-popover'].$emit('close');
      }
    },
    computed: {
      ...mapGetters('woodware', {
        stock_addresses: 'stock_addresses',
        processes: 'processes',
        production_places: 'production_places',
        delivery_addresses: 'delivery_addresses',
        users: 'users',
        partners: 'partners',
        groups: 'groups',
        wood: 'wood',
        qualities_list: 'qualities_list',
        profiles: 'profiles',
        wood_certificates: 'wood_certificates',
        pieces_list: 'pieces_list'
      }),
      ...mapState('packets', ['gridName']),
      ...mapGetters('packets', ['gridOptions', 'packets', 'columns', 'totalData']),
      ...mapGetters('generic', ['packetsGridTemplates', 'packageTypes']),
      ...mapState('woodware', ['pallet_sizes', 'bag_logos', 'pellet_diameters', 'unit_weights', 'total_weights']),
      isOperationDate() {
        return this.searchData.processes.length || this.searchData.production_places.length || this.searchData.user.length;
      },
      gridHeight() {
        if (window.innerHeight > 1024) {
          return this.showCollapse ? {height: 'calc(100vh - 575px)'} : {height: 'calc(100vh - 330px)'};
        } else {
          return this.showCollapse ? {height: '400px'} : {height: 'calc(100vh - 330px)'};
        }

      }
    },
    beforeMount() {
      this.setDefaultFilters();
      this.$store.cache.dispatch('generic/loadPackageTypes');
      this.$store.cache.dispatch('woodware/getPiecesList');
      this.$store.cache.dispatch('woodware/getProcesses');
      this.$store.cache.dispatch('woodware/getProductionPlaces');
      this.$store.cache.dispatch('woodware/getUsers');
      this.$store.dispatch('woodware/getDeliveryAddresses');
      this.$store.dispatch('woodware/getPartners', {is_active: true});
      this.$store.cache.dispatch('woodware/getWood');
      this.$store.cache.dispatch('woodware/getQualitiesList');
      this.$store.cache.dispatch('woodware/getGroupsWithHierarchy');
      this.$store.cache.dispatch('woodware/getWoodCertificates');
      this.$store.dispatch('generic/getGridTemplates', this.gridNameForTemplates);
      this.$store.cache.dispatch('woodware/fetchPalletSizes');
      this.$store.cache.dispatch('woodware/fetchBagLogos');
      this.$store.cache.dispatch('woodware/fetchPelletDiameters');
      this.$store.cache.dispatch('woodware/fetchTotalWeights');
      this.$store.cache.dispatch('woodware/fetchUnitWidths');
      this.$store.cache.dispatch('woodware/getStockAddresses');
      this.getActiveOperations();
    },
    beforeDestroy() {
      const emptyData = {
        data: [],
        used_columns: [],
        grid_name: ''
      }
      this.$store.commit('packets/setData', emptyData);
      this.$store.commit('packets/setTotalData', []);
    }
  }
</script>

<style scoped>
  .toggle-container {
    margin-top: 10px;
  }

  .total-info__item, .selected-info__item {
    font-weight: bold;
    font-size: 13px;
  }

  .total-info__item {
    margin-right: 8px;
    color: red;
  }

  .selected-info__item {
    margin-left: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/modules/manufacture/PacketsSearch.vue